import React, { useState } from 'react';
import { Header } from '../components/landing/Header';
import { HeroSection } from '../components/landing/HeroSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { VetCostsSection } from '../components/landing/VetCostsSection';
import { WhyDifferent } from '../components/landing/WhyDifferent';
import { PrudentPetBenefits } from '../components/landing/PrudentPetBenefits';
import { CaseStudySection } from '../components/landing/CaseStudySection';
import { Customization } from '../components/landing/Customization';
import { MarketingGraphics } from '../components/landing/MarketingGraphics';
import { LeadCaptureForm } from '../components/landing/LeadCaptureForm';
import { QuoteRescue } from '../components/landing/QuoteRescue';
import { TrustpilotReviews } from '../components/landing/TrustpilotReviews';
import { StateSections } from '../components/landing/StateSections';
import { SocialProof } from '../components/landing/SocialProof';
import { AboutUs } from '../components/landing/AboutUs';
import { Partners } from '../components/landing/Partners';
import { Footer } from '../components/landing/Footer';
import { ContactModal } from '../components/landing/ContactModal';
import { StickyMobileCTA } from '../components/landing/StickyMobileCTA';

const LandingPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleContactClick = () => {
    setIsContactModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={handleContactClick} />
      
      <main>
        <HeroSection />
        <HowItWorks />
        <VetCostsSection />
        <WhyDifferent />
        <PrudentPetBenefits />
        <CaseStudySection />
        <Customization />
        <LeadCaptureForm />
        <MarketingGraphics />
        <TrustpilotReviews />
        <QuoteRescue onContactClick={handleContactClick} />
        <StateSections />
        <SocialProof />
        <AboutUs />
        <Partners />
      </main>
      
      <Footer onContactClick={handleContactClick} />
      
      {/* Contact Modal */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
      
      {/* Sticky Mobile CTA */}
      <StickyMobileCTA />
      
      {/* Add padding at bottom for mobile sticky CTA */}
      <div className="h-20 md:hidden" />
    </div>
  );
};

export default LandingPage;
